
















































































































































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class LogBody extends Vue {
  @Prop() readonly data!: any;

  @Prop() readonly col!: number;

  @Prop() readonly fetchWinloseAgent!: Function;

  @Prop() readonly fetchResult!: Function;

  @Prop() readonly totalLog!: number;

  @Prop() readonly summaryLog!: number;

  @Prop() readonly paginationDetail!: object;

  utilsInstance = utils;

  handleSub(username, role) {
    this.fetchWinloseAgent(username, role);
  }
}
